// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TypographyProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { cartTotalDisplayStyles } from "@tps/Overrides/Components/CartTotalDisplay";
import { fontConfig } from "@tps/XDL/PreStyle/typography";
import { color, mergeWithCss } from "@tps/XDL/Utilities";
import { css } from "styled-components";

const sharedTextStyles: TypographyProps = {
    weight: "normal",
    size: 14,
    lineHeight: "22px",
    css: css`
        margin-bottom: 0;
    `,
};

cartTotalDisplayStyles.container = {
    gap: 0,
    offsetCss: css`
        row-gap: 8px;
    `,
};
cartTotalDisplayStyles.labelGridItem = { width: 6 };
cartTotalDisplayStyles.valueGridItem = {
    width: 6,
    css: css`
        @media print {
            & > ${TypographyStyle} {
                float: right;
            }
        }
    `,
};
cartTotalDisplayStyles.subtotalLabel = {
    ...sharedTextStyles,
};
cartTotalDisplayStyles.subtotalValue = {
    ...mergeWithCss(sharedTextStyles, {
        css: css`
            margin-left: auto;
            font-weight: bold;
        `,
    }),
};
cartTotalDisplayStyles.promotionLabel = {
    ...sharedTextStyles,
};
cartTotalDisplayStyles.promotionValue = {
    ...mergeWithCss(sharedTextStyles, {
        css: css`
            margin-left: auto;
            font-weight: bold;
            color: ${color("success")};
        `,
    }),
};
cartTotalDisplayStyles.discountsLabel = {
    ...sharedTextStyles,
};

cartTotalDisplayStyles.discountsValue = {
    ...mergeWithCss(sharedTextStyles, {
        css: css`
            margin-left: auto;
            font-weight: bold;
        `,
    }),
};
cartTotalDisplayStyles.shippingAndHandlingValue = {
    ...mergeWithCss(sharedTextStyles, {
        css: css`
            margin-left: auto;
            font-weight: bold;
        `,
    }),
};
cartTotalDisplayStyles.shippingAndHandlingLabel = {
    ...sharedTextStyles,
};
cartTotalDisplayStyles.otherChargesValue = {
    ...mergeWithCss(sharedTextStyles, {
        css: css`
            margin-left: auto;
            font-weight: bold;
        `,
    }),
};
cartTotalDisplayStyles.taxValue = {
    ...mergeWithCss(sharedTextStyles, {
        css: css`
            margin-left: auto;
            font-weight: bold;
        `,
    }),
};
cartTotalDisplayStyles.taxLabel = {
    ...sharedTextStyles,
};
cartTotalDisplayStyles.totalLabel = {
    ...sharedTextStyles,
};
cartTotalDisplayStyles.totalValue = {
    weight: "bold",
    size: 16,
    lineHeight: "26px",
    css: css`
        margin-left: auto;
    `,
};
cartTotalDisplayStyles.loadingSpinner = {
    size: 15,
    css: css`
        margin-top: auto;
        margin-bottom: auto;
        margin-left: auto;
    `,
};
cartTotalDisplayStyles.titleGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};
cartTotalDisplayStyles.titleText = {
    variant: "h5",
    as: "p",
    css: css`
        margin-bottom: 0;
    `,
};
cartTotalDisplayStyles.roundingMessageText = {
    ...fontConfig.xSmall,
    css: css`
        margin-top: 8px;
    `,
};
cartTotalDisplayStyles.dividerGridItem = {
    width: 12,
    css: css`
        border-top: 1px solid ${color("common.border")};
        &&& {
            margin: 4px 0;
        }
    `,
};
cartTotalDisplayStyles.discountValueGridItem = {
    printWidth: 7,
    css: css`
        width: auto;
        flex-grow: 1;
        padding-left: 10px;
        &&&& {
            max-width: unset;
            flex-basis: auto;
            margin-left: auto;
        }
        @media print {
            & > ${TypographyStyle} {
                float: right;
            }
        }
    `,
};
cartTotalDisplayStyles.discountLabelGridItem = {
    printWidth: 5,
    css: css`
        width: auto;
        max-width: unset;
        flex-basis: auto;
    `,
};
